document.addEventListener("DOMContentLoaded", () => {

  const fontSelector =
    document.getElementById("fontSelector");

  const fontSizeSelector =
    document.getElementById("fontSizeSelector");

  const colorSwatches =
    document.querySelectorAll(".swatch");

  /*
  FONT CHANGE
  */

  fontSelector?.addEventListener(
    "change",
    function () {

      if (!window.selectedEmbroideryLayer)
        return;

      if (
        !window.selectedEmbroideryLayer.classList.contains(
          "embroidery-text-layer"
        )
      )
        return;

      window.selectedEmbroideryLayer.style.fontFamily =
        this.value;

    }
  );

  /*
  FONT SIZE
  */

  fontSizeSelector?.addEventListener("change", () => {

  if(!window.selectedEmbroideryLayer)
    return;

  const letters =
    window.selectedEmbroideryLayer.querySelectorAll(
      ".curve-letter"
    );

  letters.forEach(letter => {

    letter.style.fontSize =
      fontSizeSelector.value + "px";

  });

  window.selectedEmbroideryLayer.dataset.fontSize =
    fontSizeSelector.value;

  document.dispatchEvent(
    new Event("embroideryUpdated")
  );

});

  /*
  COLOR
  */

  colorSwatches.forEach(
    swatch => {

      swatch.addEventListener(
        "click",
        function () {

          if (!window.selectedEmbroideryLayer)
            return;

          if (
            !window.selectedEmbroideryLayer.classList.contains(
              "embroidery-text-layer"
            )
          )
            return;

          const color =
            this.dataset.color;

          window.selectedEmbroideryLayer.style.color =
            color;

        }
      );

    }
  );

});